export const CHECK_MOBILE_SETTING = 'CHECK_MOBILE_SETTING';
export const INITIALIZE_MOBILE_SETTING = 'INITIALIZE_MOBILE_SETTING';
